var _defs, _g, _mask, _use, _path, _path2, _path3, _path4, _g2, _g3, _g4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTimeError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 172 199",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      maxWidth: 172
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8FA1B0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F7083",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8FA1B0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F7083",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8FA1B0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F7083",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "114.916868%",
    y1: "-16.0254632%",
    x2: "35.169869%",
    y2: "56.9678237%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7CCFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E9DFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0.860844766,49.7750211 C4.89593733,40.6780264 1.46572017,35.3270235 10.8011785,22.2989737 C12.3079434,20.1962158 19.4662895,16.2086324 24.0648362,11.1551388 C28.5525648,6.22342684 30.4856784,0.197175187 31.69003,0.27020201 C34.2766459,0.429150492 41.0667814,5.48388892 43.4987929,6.95983458 C45.4314739,8.13274525 51.0641072,13.190785 60.5926011,17.6376919 C70.1210951,22.0845987 76.0757408,32.9325226 84.4526503,49.7750211 C76.5134105,48.160371 71.8129223,50.0074832 70.3511857,55.3163576 C70.3816624,44.0015727 69.2600056,40.742016 66.9862154,45.5376873 C64.7124251,50.3333586 65.8340819,70.392343 70.3511857,105.714641 L8.33927423,105.714641 L17.6216302,55.3163576 C3.75771153,57.6867964 -1.82921694,55.8396842 0.860844766,49.7750211 Z",
    id: "path-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "151.692914%",
    y1: "15.8341971%",
    x2: "26.7684537%",
    y2: "53.6055982%",
    id: "linearGradient-7"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7CCFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E9DFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "85.7225549%",
    y1: "-21.7956195%",
    x2: "50%",
    y2: "50%",
    id: "linearGradient-8"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E587E",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#302C48",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "55.4021427%",
    y1: "60.1203068%",
    x2: "35.9351829%",
    y2: "46.977843%",
    id: "linearGradient-9"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#929FAA",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4DBE0",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "56.2955171%",
    y1: "60.1203068%",
    x2: "33.6092265%",
    y2: "46.977843%",
    id: "linearGradient-10"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8C6D1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3E7EB",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "57.3397201%",
    y1: "60.1203068%",
    x2: "30.8905786%",
    y2: "46.977843%",
    id: "linearGradient-11"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F9FA",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF1F3",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "69.1807018%",
    y1: "48.3056977%",
    x2: "27.9531556%",
    y2: "55.7787887%",
    id: "linearGradient-12"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F3F7",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6DCE2",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "100%",
    x2: "0%",
    y2: "100%",
    id: "linearGradient-13"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9DFE6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1CAD5",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "100%",
    x2: "0%",
    y2: "100%",
    id: "linearGradient-14"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9DFE6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1CAD5",
    offset: "100%"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Wireframes-v.2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Can't-confirm",
    transform: "translate(-122.000000, -151.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artwork",
    transform: "translate(122.000000, 150.000000)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "lines",
    opacity: 0.5,
    transform: "translate(108.420233, 15.384615) rotate(87.000000) translate(-108.420233, -15.384615) translate(93.696498, 4.682274)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4736947,10.8267692 L13.0969929,4.30280039 C12.7429955,3.61885837 11.9081689,3.35483716 11.2323557,3.7130925 C10.5565424,4.07134784 10.2956591,4.91621572 10.6496565,5.60015774 L14.0263583,12.1241265 C14.3803557,12.8080685 15.2151823,13.0720897 15.8909956,12.7138344 C16.5668088,12.3555791 16.8276921,11.5107112 16.4736947,10.8267692 Z",
    id: "Line",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.97936147,18.312849 L4.60164329,11.7876092 C4.2475393,11.1035339 3.41273451,10.83932 2.73705462,11.1974709 C2.06137472,11.5556219 1.80068593,12.4005131 2.15478992,13.0845884 L5.53250811,19.6098282 C5.8866121,20.2939035 6.72141688,20.5581174 7.39709678,20.1999665 C8.07277668,19.8418156 8.33346546,18.9969243 7.97936147,18.312849 Z",
    id: "Line-Copy",
    fill: "url(#linearGradient-2)",
    transform: "translate(5.067076, 15.698719) rotate(-24.000000) translate(-5.067076, -15.698719) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.78819,8.42200465 L23.4134868,1.89794346 C23.0596988,1.21399176 22.2250482,0.9501314 21.5492424,1.30859486 C20.8734366,1.66705831 20.6123895,2.51210276 20.9661775,3.19605446 L24.3408807,9.72011565 C24.6946687,10.4040673 25.5293193,10.6679277 26.2051251,10.3094643 C26.8809309,9.9510008 27.141978,9.10595635 26.78819,8.42200465 Z",
    id: "Line-Copy-2",
    fill: "url(#linearGradient-3)",
    transform: "translate(23.877184, 5.809030) rotate(30.000000) translate(-23.877184, -5.809030) "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shirt",
    transform: "translate(43.501946, 62.207358)"
  }, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "url(#linearGradient-4)",
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.9508364,15.7734809 C34.6690086,15.388215 44.4523508,11.2351469 45.3008629,3.31427651 C46.149375,-4.60659385 41.2581326,-7.132101 30.6271358,-4.26224494 L15.9508364,15.7734809 Z",
    id: "Path-6",
    fill: "url(#linearGradient-7)",
    opacity: 0.184839221,
    style: {
      mixBlendMode: "multiply"
    },
    mask: "url(#mask-6)",
    transform: "translate(30.672888, 5.183177) rotate(10.000000) translate(-30.672888, -5.183177) "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M107.081116,103.682823 C115.604978,122.690707 122.727779,136.492484 128.154513,136.966613 C135.24127,138.496696 149.446438,128.554781 164.232258,120.227789 L165.305901,107.972834 C157.814055,117.531823 142.540261,119.157125 135.37018,122.397845 C132.846261,121.219176 127.427126,114.990724 119.910051,88.9610346 L107.081116,103.682823 Z",
    id: "arm",
    fill: "#6E9DFF",
    fillRule: "nonzero",
    transform: "translate(136.193509, 113.042413) rotate(-12.000000) translate(-136.193509, -113.042413) "
  })), /*#__PURE__*/React.createElement("g", {
    id: "head",
    transform: "translate(60.233463, 11.371237)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7985641,7.08615157 C31.3807214,7.08615157 38.4167903,14.9283971 37.5140639,24.6014864 L35.7668068,43.3240726 C34.8640803,52.9971619 28.6111973,60.8382829 21.8006016,60.8382829 C14.990006,60.8382829 8.73652844,52.996172 7.83306863,43.3230143 L6.08439208,24.6002956 C5.18093226,14.9271379 12.2164067,7.08615157 21.7985641,7.08615157 Z",
    id: "Rectangle-21",
    fill: "#FF7C7C",
    transform: "translate(21.799165, 33.962217) rotate(-4.000000) translate(-21.799165, -33.962217) "
  })), /*#__PURE__*/React.createElement("path", {
    d: "M34.794703,20.66986 C31.8883683,22.427349 28.6662977,23.8419612 25.6128581,23.5212065 C16.0831676,22.520141 19.9569227,23.5271046 18.0673165,25.7420629 L13.4856511,40.2855528 C13.4012873,47.5051891 16.3768263,56.2051875 20.6909977,60.489825 C14.9958768,59.0250996 9.86399678,52.4498826 8.52006553,44.2750765 L5.46961784,25.7199469 C3.89359343,16.1333747 10.3649702,7.82071869 19.9237859,7.15230118 C29.4826016,6.48388367 28.6476121,9.33889779 34.0880519,11.0512547 L34.794703,20.66986 Z",
    id: "Combined-Shape",
    fill: "#FF7C7C",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.275079257
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.51791167,45.6478301 C6.41824731,43.4098567 4.89725456,40.7905302 3.95493341,37.7898504 C1.04597704,28.5267171 -0.0775709224,17.7120288 0.36526238,13.0563664 C1.39598005,2.2200689 14.3405138,-3.27505142 26.2760731,2.2200689 C38.2116325,7.71518922 40.5782014,18.1753268 37.6913602,19.9292623 C34.804519,21.6831978 16.0148936,22.3990575 12.2664026,18.1753268 C8.2369845,19.3446171 6.98748751,28.5021182 8.51791167,45.6478301 Z",
    id: "Path-43",
    fill: "url(#linearGradient-8)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.97361879,34.9239399 C11.4517548,34.9237996 13.1619299,33.4699274 13.162081,30.8014707 C13.1622321,28.1330141 11.1534285,25.9699162 8.67529252,25.9700565 C6.19715655,25.9701967 4.78589585,25.9919259 4.78574474,28.6603825 C4.78559363,31.3288392 6.49548283,34.9240801 8.97361879,34.9239399 Z",
    id: "Oval-10",
    fill: "#FF6A6A",
    transform: "translate(8.973913, 30.446998) rotate(6.000000) translate(-8.973913, -30.446998) "
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "paper",
    transform: "translate(0.000000, 62.207358)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.70038911,0 C20.8305,12.2493607 31.4649206,19.6468509 40.6036507,22.1924706 C49.7423809,24.7380903 65.9230057,28.7393641 89.1455253,34.1962922 L89.1455253,135.675985 C67.8824156,132.690375 51.7017907,129.410344 40.6036507,125.835891 C29.5055107,122.261438 22.8866544,116.372359 20.7470817,108.168656 L8.70038911,0 Z",
    id: "Rectangle-22-Copy-3",
    fill: "url(#linearGradient-9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.0155642,2.67558528 C19.2688917,14.4790151 31.4649206,21.6535399 40.6036507,24.1991596 C49.7423809,26.7447792 65.9230057,30.0771568 89.1455253,34.1962922 L89.1455253,135.675985 C67.8824156,132.690375 51.7017907,129.410344 40.6036507,125.835891 C29.5055107,122.261438 21.3250461,117.264221 16.0622568,110.844241 L4.0155642,2.67558528 Z",
    id: "Rectangle-22-Copy-2",
    fill: "url(#linearGradient-10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,8.69565217 C17.9303703,17.8234967 31.4649206,23.6602288 40.6036507,26.2058485 C49.7423809,28.7514682 65.9230057,31.191984 89.1455253,33.5273958 L89.1455253,137.682674 C67.8824156,134.697064 51.7017907,131.417033 40.6036507,127.84258 C29.5055107,124.268127 19.9865247,119.27091 12.0466926,112.85093 L0,8.69565217 Z",
    id: "Rectangle-22",
    fill: "url(#linearGradient-11)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172,11.8997481 L163.165759,116.055026 C146.726148,118.028731 134.261618,120.244717 125.772169,122.702986 C117.282719,125.161254 104.850751,130.154484 88.4762646,137.682674 L88.4762646,33.5273958 C102.918299,25.1161148 115.350267,19.56115 125.772169,16.8625015 C136.19407,14.163853 151.603347,12.5096018 172,11.8997481 Z M107.345164,59.5395515 L107.93493,64.0143007 L107.209091,67.1990604 L106.484299,70.324884 L109.85363,73.5562595 L106.759692,79.3353064 L107.413911,82.5445334 L105.943853,85.1587219 L108.168709,88.7328447 L106.739121,93.0514843 L106.675903,97.2119457 L111.796058,95.3841192 L114.544417,95.1345773 L117.003616,93.6438734 L120.001738,91.3450102 L123.812217,91.476943 L125.994376,91.9471395 L129.82642,89.6974155 L132.916619,90.7475808 L136.218124,88.9380283 L138.28573,88.0234835 L142.499969,89.7550726 L146.094988,87.9803982 L150.781547,87.2077735 L151.858202,84.1865444 L150.207251,80.5819608 L152.025193,76.4254041 L150.858161,73.2061938 L151.753378,68.9645259 L153.240324,66.1783088 L152.114328,62.188774 L150.987887,58.2075782 L152.531235,54.3625688 L152.976937,45.9958351 L144.550169,47.0871303 L139.486499,49.0806855 L135.33624,48.2803655 C132.73262,48.7479332 130.896013,49.1012502 129.82642,49.3403167 C129.176862,49.4855005 127.120842,51.1388188 123.658358,54.3002717 L118.098179,54.008716 L114.931139,54.193719 L111.797052,57.0384625 L107.345164,59.5395515 Z",
    id: "Combined-Shape",
    fill: "url(#linearGradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.735409,40.6145309 C109.656453,37.4642458 117.08183,34.6181374 126.011539,32.076206 C134.941249,29.5342745 144.094045,28.1071702 153.469929,27.7948932 L153.469929,36.882236 C144.276227,36.9416827 135.685602,37.9657991 127.698054,39.9545851 C119.710505,41.9433712 111.722957,45.2699499 103.735409,49.9343212 L103.735409,40.6145309 Z",
    id: "Path-3",
    fill: "url(#linearGradient-13)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.743191,108.173059 C109.446143,105.454392 115.762475,102.824092 124.692184,100.282161 C133.621894,97.7402292 142.348414,96.3949714 150.871745,96.2463872 L150.202484,103.995937 C143.147181,104.061821 135.625755,105.089156 127.638207,107.077942 C119.650659,109.066728 112.35232,112.315398 105.743191,116.823953 L105.743191,108.173059 Z",
    id: "Path-3-Copy",
    fill: "url(#linearGradient-14)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5160851,39.6946836 C21.9695768,42.7479904 25.4188334,45.2044562 34.9820578,48.053763 C48.9530662,52.2163434 62.8736563,53.9589767 76.448567,52.5912693 L75.7672688,46.0399441 C63.4522086,47.2807183 50.4378672,45.5887607 37.4700485,41.7250749 C28.5129633,39.0563637 19.6745827,35.5942979 14.7270174,32.8242498 L16.5160851,39.6946836 Z",
    id: "Path-4",
    fill: "#D1D9E0",
    fillRule: "nonzero",
    opacity: 0.600000024,
    transform: "translate(45.587792, 42.937102) rotate(4.000000) translate(-45.587792, -42.937102) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0527537,53.7523442 C23.506314,56.8057479 26.9544018,59.2389584 36.517699,62.0884402 C50.4888139,66.2512763 63.0742029,68.0875144 76.6491147,66.7200662 L75.965247,60.1221098 C63.6501858,61.3626488 51.9734925,59.6237349 39.0055751,55.7598117 C30.0484216,53.0909366 21.8775888,49.582038 16.9299613,46.8119019 L18.0527537,53.7523442 Z",
    id: "Path-4-Copy",
    fill: "#D1D9E0",
    fillRule: "nonzero",
    opacity: 0.600000024,
    transform: "translate(46.789538, 56.989324) rotate(2.000000) translate(-46.789538, -56.989324) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6782598,67.1533276 C25.009323,70.2067827 29.8666585,73.2972373 39.2151236,76.1468106 C52.872388,80.3097802 63.5911604,80.7966878 76.8610731,79.429372 L76.1618439,72.8080719 C64.1234756,74.0484908 54.3236504,73.6822565 41.6470473,69.8182094 C32.8911095,67.1492486 23.4017917,62.9713904 18.5652971,60.2013858 L19.6782598,67.1533276 Z",
    id: "Path-4-Copy-2",
    fill: "#D1D9E0",
    fillRule: "nonzero",
    opacity: 0.600000024,
    transform: "translate(47.713185, 70.157038) rotate(1.000000) translate(-47.713185, -70.157038) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9157904,75.7651326 L24.0975063,106.931124 C31.8891772,111.605483 40.5183331,114.423313 49.9849741,115.384615 C48.3723506,104.39462 48.3723506,98.9047344 48.3723506,85.7986282 C37.549864,84.1389857 28.3976773,80.7944872 20.9157904,75.7651326 Z",
    id: "Path-5",
    fill: "#D1D9E0",
    opacity: 0.600000024
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "fingers",
    transform: "translate(163.968872, 98.327759)",
    fill: "#FF7C7C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.06043544,1.18935153 L5.97107311,1.18885172 C6.7918255,1.18874683 7.4572618,1.85401306 7.4573667,2.67476544 C7.45736672,2.6748921 7.45736672,2.67501875 7.4573667,2.6751454 C7.45726172,3.49616913 6.79171669,4.16171411 5.97069297,4.16181904 L2.06005529,4.16231885 C1.23930291,4.16242374 0.573866601,3.49715751 0.573761704,2.67640513 C0.573761688,2.67627847 0.573761688,2.67615182 0.573761704,2.67602517 C0.573866686,1.85500144 1.23941171,1.18945646 2.06043544,1.18935153 Z",
    id: "Rectangle-23",
    transform: "translate(4.015564, 2.675585) rotate(14.000000) translate(-4.015564, -2.675585) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.06043544,4.75679857 L5.97107311,4.75629877 C6.7918255,4.75619387 7.4572618,5.4214601 7.4573667,6.24221249 C7.45736672,6.24233914 7.45736672,6.24246579 7.4573667,6.24259245 C7.45726172,7.06361617 6.79171669,7.72916116 5.97069297,7.72926609 L2.06005529,7.72976589 C1.23930291,7.72987079 0.573866601,7.06460456 0.573761704,6.24385217 C0.573761688,6.24372552 0.573761688,6.24359887 0.573761704,6.24347221 C0.573866686,5.42244849 1.23941171,4.7569035 2.06043544,4.75679857 Z",
    id: "Rectangle-23-Copy",
    transform: "translate(4.015564, 6.243032) rotate(14.000000) translate(-4.015564, -6.243032) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.06043544,8.32424562 L5.97107311,8.32374581 C6.7918255,8.32364092 7.4572618,8.98890715 7.4573667,9.80965953 C7.45736672,9.80978619 7.45736672,9.80991284 7.4573667,9.81003949 C7.45726172,10.6310632 6.79171669,11.2966082 5.97069297,11.2967131 L2.06005529,11.2972129 C1.23930291,11.2973178 0.573866601,10.6320516 0.573761704,9.81129922 C0.573761688,9.81117256 0.573761688,9.81104591 0.573761704,9.81091926 C0.573866686,8.98989553 1.23941171,8.32435055 2.06043544,8.32424562 Z",
    id: "Rectangle-23-Copy-2",
    transform: "translate(4.015564, 9.810479) rotate(14.000000) translate(-4.015564, -9.810479) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.06043544,11.8916927 L5.97107311,11.8911929 C6.7918255,11.891088 7.4572618,12.5563542 7.4573667,13.3771066 C7.45736672,13.3772332 7.45736672,13.3773599 7.4573667,13.3774865 C7.45726172,14.1985103 6.79171669,14.8640552 5.97069297,14.8641602 L2.06005529,14.86466 C1.23930291,14.8647649 0.573866601,14.1994986 0.573761704,13.3787463 C0.573761688,13.3786196 0.573761688,13.378493 0.573761704,13.3783663 C0.573866686,12.5573426 1.23941171,11.8917976 2.06043544,11.8916927 Z",
    id: "Rectangle-23-Copy-3",
    transform: "translate(4.015564, 13.377926) rotate(14.000000) translate(-4.015564, -13.377926) "
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "fingers",
    transform: "translate(6.023346, 124.080268) scale(-1, -1) rotate(-10.000000) translate(-6.023346, -124.080268) translate(2.007782, 116.387960)",
    fill: "#FF7C7C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.00737369,1.33800667 L6.02409685,1.33749331 C6.76277399,1.3373989 7.36166667,1.93613851 7.36176108,2.67481566 C7.36176109,2.67492965 7.36176109,2.67504363 7.36176108,2.67515762 C7.36166659,3.41407897 6.76267607,4.01306946 6.02375472,4.0131639 L2.00703156,4.01367726 C1.26835441,4.01377167 0.669461737,3.41503206 0.669367329,2.67635491 C0.669367315,2.67624092 0.669367315,2.67612694 0.669367329,2.67601295 C0.669461813,1.93709159 1.26845233,1.33810111 2.00737369,1.33800667 Z",
    id: "Rectangle-23",
    transform: "translate(4.015564, 2.675585) rotate(14.000000) translate(-4.015564, -2.675585) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.00737369,4.68248828 L6.02409685,4.68197492 C6.76277399,4.68188051 7.36166667,5.28062012 7.36176108,6.01929726 C7.36176109,6.01941125 7.36176109,6.01952524 7.36176108,6.01963923 C7.36166659,6.75856058 6.76267607,7.35755106 6.02375472,7.3576455 L2.00703156,7.35815886 C1.26835441,7.35825327 0.669461737,6.75951366 0.669367329,6.02083652 C0.669367315,6.02072253 0.669367315,6.02060854 0.669367329,6.02049455 C0.669461813,5.2815732 1.26845233,4.68258272 2.00737369,4.68248828 Z",
    id: "Rectangle-23-Copy",
    transform: "translate(4.015564, 6.020067) rotate(14.000000) translate(-4.015564, -6.020067) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.00737369,8.02696988 L6.02409685,8.02645652 C6.76277399,8.02636211 7.36166667,8.62510172 7.36176108,9.36377887 C7.36176109,9.36389286 7.36176109,9.36400684 7.36176108,9.36412083 C7.36166659,10.1030422 6.76267607,10.7020327 6.02375472,10.7021271 L2.00703156,10.7026405 C1.26835441,10.7027349 0.669461737,10.1039953 0.669367329,9.36531812 C0.669367315,9.36520413 0.669367315,9.36509015 0.669367329,9.36497616 C0.669461813,8.62605481 1.26845233,8.02706432 2.00737369,8.02696988 Z",
    id: "Rectangle-23-Copy-2",
    transform: "translate(4.015564, 9.364548) rotate(14.000000) translate(-4.015564, -9.364548) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.12358959,11.3816135 L6.14031275,11.3811002 C6.87898989,11.3810058 7.47788257,11.9797454 7.47797698,12.7184225 C7.47797699,12.7185365 7.47797699,12.7186505 7.47797698,12.7187645 C7.47788249,13.4576858 6.87889197,14.0566763 6.13997062,14.0567708 L2.12324746,14.0572841 C1.38457031,14.0573785 0.785677638,13.4586389 0.78558323,12.7199618 C0.785583216,12.7198478 0.785583216,12.7197338 0.78558323,12.7196198 C0.785677714,11.9806984 1.38466824,11.381708 2.12358959,11.3816135 Z",
    id: "Rectangle-23-Copy-3",
    transform: "translate(4.131780, 12.719192) rotate(14.000000) translate(-4.131780, -12.719192) "
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeError);
export default __webpack_public_path__ + "static/media/time-error.d1e424f5.svg";
export { ForwardRef as ReactComponent };